import {HTTP} from '../http-common';
import discovery from '../discovery';

export default {
    // Constantes
    //TIPO:1,
    // Funciones comunes
    checkVersionHeader: function (response) {
        var version = response.headers['x-service-version'];
        if (window.$vue.$store.state.formio.serviceVersion != version) {
            window.$vue.$store.commit('formio/setServiceVersion',version);
            //console.log("Service version:"+version);
        }
    },
    getCommonHeaders()
    {
        var headers = {};

        headers = {
            //'x-jwt-token': window.localStorage.getItem("formioToken")
        };
 
        if (/MSIE|Trident/.test(window.navigator.userAgent))
        {
            headers['Pragma'] = 'no-cache';
            headers['Cache-Control'] = 'no-cache, no-store';
        }

        return { headers: headers };
    },
    genericGet(service,cbok, cberr)
    {
        HTTP
            .get(discovery.fundattio_service_url+service,
            this.getCommonHeaders())
            .then((response) => {
                //this.checkVersionHeader(response);
                cbok(response.data);
            }).catch(function (error) {
                cberr(error);
            });
    },
    genericPut (service,data,cbok, cberr)
    {
        HTTP
            .put(discovery.fundattio_service_url+service,
            data,this.getCommonHeaders())
            .then((response) => {
                if (cbok)
                    cbok(response.data);
            }).catch(function (error) {
                if (cberr)
                    cberr(error);
            });
    },
    genericPost(service,data,cbok, cberr)
    {
        HTTP
            .post(discovery.fundattio_service_url+service,
            data,this.getCommonHeaders())
            .then((response) => {
                cbok(response.data);
            }).catch(function (error) {
                cberr(error);
            });
    },
    genericDelete(service,cbok, cberr)
    {
        HTTP
            .delete(discovery.fundattio_service_url+service,
            this.getCommonHeaders())
            .then((response) => {
                cbok(response.data);
            }).catch(function (error) {
                cberr(error);
            });
    },

    /////////////////////////////////////////////////////////////////
    
		getFormSubmissionInfoByToken (token, cbok, cberr)
		{
        this.genericGet(`form-submission/${token}/info`, cbok, cberr);
		},
		storeFormSubmissionData (id, data, cbok, cberr)
		{
        this.genericPut(`form-submission/${id}/store-data`, data, cbok, cberr);
		},
		submitFormSubmissionData (id, data, cbok, cberr)
		{
        this.genericPut(`form-submission/${id}/submit-data`, data, cbok, cberr);
		}
    /*getLatestNews (cbok, cberr)
    {
        this.genericGet('content/news', cbok, cberr);
    },
    getForms(cbok, cberr)
    {
        this.genericGet('form?tags=common&type=form&limit=1000', cbok, cberr);
    },
    createForm (fd,cbok, cberr)
    {
        this.genericPost('form', fd, cbok, cberr);
    },
    formioLogin(email, password, cbok, cberr) {

        let body = { data: {
            email: email,
            password: password
          }
        };

        HTTP.post(discovery.formio_api_url + 'user/login/submission', body)
        .then((response) => {
            cbok(response.headers['x-jwt-token']);
        }).catch(function (error) {
            cberr(error);
        });
      },
      callWebhook(url,data, cbok, cberr) {
          this.genericPost(url,data, cbok, cberr);
      }*/
}
